import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function SmsForm({
  challengeResponse,
  setChallengeResponse,
  handleChallengeResponse,
}) {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    handleChallengeResponse();
  };

  return (
    <AuthPage
      title={t("enterSmsCode")}
      subtitle={t("verificationCodeSubtitle")}
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="sms-code"
            className="text-sm font-medium text-slate-700"
          >
            {t("verificationCode")}
          </label>
          <input
            id="sms-code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={challengeResponse}
            onChange={(event) =>
              setChallengeResponse(event.target.value.replace(/\s/g, ""))
            }
            className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-center text-lg tracking-[0.35em] text-gray-900 shadow-sm outline-none transition focus:border-sky-600 focus:ring-2 focus:ring-sky-200"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700"
        >
          {t("confirm")}
        </button>
      </form>
    </AuthPage>
  );
}
